"use client";

import type { UseOpenApiMutationOptions } from "@packages/sdk";
import { useOpenApiMutation } from "@packages/sdk";

const urlBackendPath = "/me/pin/forgot" as const;

export const useRequestMePinForgotPost = (
  props: Partial<UseOpenApiMutationOptions<typeof urlBackendPath, "POST">> = {},
) =>
  useOpenApiMutation({
    method: "POST",
    urlBackendPath,
    meta: { suppressErrorToast: true },
    ...props,
  });
